import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../localization/language';
import cx from 'classnames';
import * as commonActions from '../actions/common';

class SuccessVerifyEmail extends React.Component {
	render() {
		return (
			<div className={cx("content", "content-success-verify")}>
				<div className="content-item content-item--ipage content-item--ipage-success">
					<div className="content-item__title">
						{ trans('verify_email_title') }
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__result content__result--successful">
								<div className="content__result-icon content__result-icon--successful"></div>
								<div className="content__result-txt">
									{ trans('verify_email_success') }
								</div>
							</div>
							<div className="content__submit-wrap">
								<a href="#" className="content__submit" onClick={() => this.props.logout()}>{trans('back_home')}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(null, mapDispatchToProps)(SuccessVerifyEmail);



// WEBPACK FOOTER //
// ./app/components/SuccessVerifyEmail.js